import { createContext } from "react";

export const ColumnContext = createContext<string>("");
export const ColumnProvider = ColumnContext.Provider;
